module.exports = __webpack_public_path__ + "img/Dm-Reg.e3039498.svg";